export default __webpack_public_path__ + "static/media/redo.23b1c9c0.svg";